/**
 * Page shell for the Repairs section (/repairs): Submissions and Pricing
 * render as tabs.
 */
import { DashboardResources } from '@src/types';
import SectionTabShell, { type SectionTab } from '@src/components/SectionTabShell';

export type RepairsTab = 'submissions' | 'pricing';

export const REPAIRS_TABS: SectionTab<RepairsTab>[] = [
  {
    value: 'submissions',
    label: 'Submissions',
    path: `/${DashboardResources.Repairs}`,
    resource: DashboardResources.Repairs,
  },
  {
    value: 'pricing',
    label: 'Pricing',
    path: `/${DashboardResources.RepairPricing}`,
    resource: DashboardResources.RepairPricing,
  },
];

const TAB_DESCRIPTIONS: Record<RepairsTab, string> = {
  submissions: 'Review and manage repair requests submitted by customers.',
  pricing: 'Prices charged for each repair problem, location and severity.',
};

interface RepairsTabShellProps {
  tab: RepairsTab;
  children: React.ReactNode;
}

const RepairsTabShell = ({ tab, children }: RepairsTabShellProps) => (
  <SectionTabShell title="Repairs" description={TAB_DESCRIPTIONS[tab]} tabs={REPAIRS_TABS} tab={tab}>
    {children}
  </SectionTabShell>
);

export default RepairsTabShell;
